import {CalendarHeartIcon} from 'lucide-react';
import type {RouteObject} from 'react-router-dom';

import type {MenuItemElement} from '@/components/menu/Menu';
import i18n from '@/i18n';
import {protectedLoader} from '@/utils/protectedLoader';

export const routes = [
  {
    path: 'events',
    children: [
      {
        path: '',
        loader: protectedLoader('EVENTS', 'VIEW_EVENTS'),
        async lazy() {
          const {EventsPage} = await import('./pages/EventsPage');
          return {element: <EventsPage />};
        },
      },
    ],
  },
] as RouteObject[];

export const menuItems = [
  {
    path: '/events',
    text: i18n.t('Events'),
    icon: <CalendarHeartIcon />,
    permission: 'VIEW_EVENTS',
    entitlement: 'EVENTS',
  },
] as MenuItemElement[];
